exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RadioVcDemo .check-value[data-v-fc24e59e]{margin:15px 10px 5px}", ""]);

// exports
